module.exports = __webpack_public_path__ + "img/plus.b9cd5fca.svg";